import { createFileRoute } from '@tanstack/react-router'
import NewEquipment from '@/pages/equipments/new-equipment'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/equipments/new'
)({
  component: NewEquipment,
})
